import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, ModalFooter, Button, Table } from "reactstrap";
import style from "./Trade.module.scss";
import { OrderStatus, CommonsHelper, ProductType, OrderPriceType } from "../../../utils";
import { debounce } from "../../../utils/Helper";
import CircularProgress from "../../CircularProgress/CircularProgress";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import ItemRow from "../Cross/ItemRow";
import { Field, Combobox } from "../Order/Field/Field";
import { EmptyOrders, AlertError, FooterForm, HeaderForm, Number } from "./Utils";
import Trading from "./Trading";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";

const { localDateTime } = CommonsHelper;

const defaultSides = (price) => ({
  buy: [{ id: 1, price, route: null, date: new Date().toDatetimeLocal() }],
  sell: [{ id: 1, price, route: null, date: new Date().toDatetimeLocal() }],
});

class Trade extends Component {
  constructor(props) {
    super(props);

    const fields = this.props.defaultFields();

    this.tradingRef = React.createRef();
    this.state = {
      entities: {
        routes: [],
        accounts: null,
        errorAccounts: null,
        orders: null,
      },
      loadings: {
        execute: false,
        distribute: false,
      },
      items: {
        account: { enabled: false },
        errorAccount: { enabled: false },
        trading: {
          enabled: false,
          sides: defaultSides(fields.price),
        },
      },
      ui: {
        distributed: false,
        leftOvers: null,
      },
      errors: {},
      fields,
      showFees: false,
    };
  }

  componentDidMount() {
    const { fetchTradingRoutesForAsset, fetchSearchAccount, fetchSearchErrorAccount, getBooktypes } = this.props.services;
    const { fields } = this.state;
    const { tradeId, asset, tradeCurrencyId, form, manualFX, quantity } = fields;

    if (asset && asset.id) {
      fetchTradingRoutesForAsset({ assetId: asset.id, quantity: quantity }).then((res) => {
        this.setState((state) => ({
          entities: {
            ...state.entities,
            routes: res.response.sorroutes.map((r) => ({
              id: r.id,
              description: r.name,
            })),
          },
        }));
      });
    }

    const isFX = form == "Forex";

    if ((isFX && tradeCurrencyId) || asset.id) {
      this.getSettlementCurrencies(!tradeId, !manualFX);

      this.getTradePossibleOrders(true, true);
    }

    // retrieve accounts
    fetchSearchAccount({ text: "", length: 99 })
      .then((res) => res.response.accounts)
      .then((accounts) =>
        this.setState((state) => ({
          entities: {
            ...state.entities,
            accounts: accounts.map((a) => ({
              id: a.Id,
              description: JSON.parse(a.Value).value,
            })),
          },
        }))
      );

    // retrieve error accounts
    fetchSearchErrorAccount({ text: "", length: 99 })
      .then((res) => res.response.accounts)
      .then((accounts) =>
        this.setState((state) => ({
          entities: {
            ...state.entities,
            errorAccounts: accounts.map((a) => ({
              id: a.Id,
              description: JSON.parse(a.Value).value,
            })),
          },
        }))
      );

    if (getBooktypes) {
      const isTrader = this.state.ui.userRole === "Trader";
      getBooktypes(isTrader).then((r) => {
        if (r.response && r.response.booktypes) {
          this.setState((state) => ({...state,
            entities: {
              ...state.entities,
              booktypes: r.response.booktypes
            },
          }));
        }
      })
      } else {
        this.setState((state) => ({...state,
          entities: {
            ...state.entities,
            booktypes: []
          },
        }));
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { fetchTradePossibleOrders, fetchTradingRoutesForAsset, getExecutionFees, fetchGetCalculator } =
      this.props.services;
    const { fields } = this.state;
    const {
      tradeId,
      side,
      form,
      asset,
      price,
      settlementCurrencyId,
      tradeCurrencyId,
      quantity,
      date,
      valueDate,
      manualFX,
      route,
    } = fields;
    const { fields: prevFields } = prevState;
    const {
      side: prevSide,
      form: prevForm,
      asset: prevAsset,
      price: prevPrice,
      settlementCurrencyId: prevSettlementCurrencyId,
      tradeCurrencyId: prevTradeCurrencyId,
      date: prevDate,
      valueDate: prevValueDate,
      route: prevRoute,
      quantity: prevQuantity,
    } = prevFields;

    if (
      side !== prevSide ||
      form !== prevForm ||
      asset.id !== prevAsset.id ||
      price !== prevPrice ||
      settlementCurrencyId !== prevSettlementCurrencyId ||
      tradeCurrencyId !== prevTradeCurrencyId ||
      date !== prevDate ||
      valueDate !== prevValueDate
    ) {
      const isFX = form == "Forex";

      if (asset.id !== prevAsset.id || tradeCurrencyId !== prevTradeCurrencyId || date !== prevDate) {
        if ((isFX && tradeCurrencyId) || asset.id) {
          this.getSettlementCurrencies(true, !manualFX);
        }
      }

      if (
        side !== prevSide ||
        form !== prevForm ||
        asset.id !== prevAsset.id ||
        price !== prevPrice ||
        settlementCurrencyId !== prevSettlementCurrencyId ||
        tradeCurrencyId !== prevTradeCurrencyId
      ) {
        this.getTradePossibleOrdersDebounced(false, false);
      }

      if (form != prevForm) {
        this.setState((state) => ({
          entities: {
            ...state.entities,
            asset: {
              id: null,
              name: null,
              error: null,
            },
            routes: [],
          },
        }));
      } else if (asset.id != prevAsset.id) {
        if (asset.id) {
          this.setState((state) => ({
            entities: {
              ...state.entities,
              routes: null,
            },
          }));
          fetchTradingRoutesForAsset({ assetId: asset.id, quantity: quantity }).then((res) => {
            this.setState((state) => ({
              entities: {
                ...state.entities,
                routes: res.response.sorroutes.map((r) => ({
                  id: r.id,
                  description: r.name,
                })),
              },
            }));
          });
        } else {
          this.setState((state) => ({
            entities: {
              ...state.entities,
              routes: [],
            },
          }));
        }
      }
    }

    if (price !== prevPrice || quantity !== prevQuantity || route !== prevRoute || date !== prevDate) {
      const body = {
        assetId: asset.id,
        isSecurity: true,
        quantity: quantity || 0,
        price: price || 0,
        date: date,
      };

      fetchGetCalculator(body)
        .then((res) => {
          const ExecutionTotal = res.calculator.total;

          getExecutionFees({
            execution: {
              ExecutionQuantity: quantity || 0,
              ExecutionPrice: price || 0,
              ExecutionValueDate: date,
              TradingRouteId: route || 0,
              ExecutionTotal: ExecutionTotal,
              SettlementCurrencyId: this.state.fields.settlementCurrencyId,
            },
          }).then(({ response }) => {
            const newFees = response.execution.Fees;

            this.setState({
              ...this.state,
              fields: {
                ...this.state.fields,
                Fees: newFees,
              },
            });
          });
        })
        .catch((err) => {
          console.error(err);
          showToast("Error fetching fees");
        });
    }
  }

  getTradePossibleOrdersDebounced = debounce((updateSelectedOrders, checkDefaultOrder) => {
    this.getTradePossibleOrders(updateSelectedOrders, checkDefaultOrder);
  }, 600);

  getTradePossibleOrders = (updateSelectedOrders, checkDefaultOrder) => {
    const { services, defaultSelectedOrderId } = this.props;
    const { fetchTradePossibleOrders } = services;
    const { fields } = this.state;
    const { tradeId, side, form, asset, price, quantity, settlementCurrencyId } = fields;

    this.setState((state) => ({
      loadings: {
        ...state.loadings,
        distribute: true,
      },
    }));

    fetchTradePossibleOrders({
      trade: {
        TradeId: tradeId,
        TradeSide: side == "Sell" ? "SELL" : "BUY",
        TradeAssetClassForm: form,
        TradeAssetId: asset.id,
        TradeAvgPrice: price,
        TradeQuantity: quantity,
        TradeSettleCurrencyId: settlementCurrencyId,
      },
    })
      .then((res) => res.response.tradeOrders)
      .then((orders) => {
        const categorizedOrders = this.categorizeFetchedOrders(orders);

        const selectedOrders = updateSelectedOrders ? categorizedOrders.orderItems : {};

        if (checkDefaultOrder && defaultSelectedOrderId) {
          const orderToCheck = selectedOrders[defaultSelectedOrderId];
          if (orderToCheck) {
            orderToCheck.enabled = true;
            orderToCheck.quantity = quantity;
          }
        }

        const updateTradeQuantityOnRefresh = checkDefaultOrder;

        this.setState(
          (state) => ({
            entities: {
              ...state.entities,
              orders: categorizedOrders.clientOrders,
              propOrders: categorizedOrders.propOrders,
            },
            items: {
              ...state.items,
              ...selectedOrders,
              trading: {
                ...state.items.trading,
                enabled: state.items.trading.enabled || categorizedOrders.tradingIsEnabled,
                sides: categorizedOrders.tradingSides,
              },
            },
            loadings: {
              ...state.loadings,
              distribute: false,
            },
          }),
          () => this.refreshTotals(updateTradeQuantityOnRefresh)
        );
      });
  };

  getSettlementCurrencies = (updateValueDate, updateFX) => {
    const { services } = this.props;
    const { fetchOrderAssetInfo } = services;
    const { fields } = this.state;

    const data = {
      tradeDate: fields.date,
      valueDate: fields.valueDate,
      useValueDate: !updateValueDate,
      orderForm: fields.form,
      assetId: fields.asset.id,
      assetTicker: "",
      tradeCurrencyId: fields.tradeCurrencyId,
      settleCurrencyId: fields.settlementCurrencyId,
    };

    const currentSettleCurrency = fields.settlementCurrencyId;
    const currentSettleCurrencySymbol = fields.settlementCurrencySymbol;

    fetchOrderAssetInfo(data).then((res) => {
      const { settlementCurrency: settlementCurrencies, items } = res.response.assetorderdata;

      const tradeCurrencyISO = items.find((i) => i.key == "Currency").value;
      const maxDecimals = items.find((i) => i.key == "MaxDecimals").value;

      this.setState((state) => ({
        ...state,
        maxDecimals,
      }));

      if (settlementCurrencies) {
        const settlementCurrenciesList = settlementCurrencies.map((c) => ({
          id: c.currencyInfo.currencyId,
          description: c.currencyInfo.currencyISO,
          multiplies: c.multiplies,
          FX: c.fx,
        }));

        let settleCurrencyId = currentSettleCurrency;
        let settleCurrencySymbol = currentSettleCurrencySymbol;
        if (
          currentSettleCurrency == 0 ||
          !settlementCurrenciesList.find((c) => c.id == currentSettleCurrency)
        ) {
          settleCurrencyId = settlementCurrenciesList[0] ? settlementCurrenciesList[0].id : 0;
          settleCurrencySymbol = settlementCurrenciesList[0] ? settlementCurrenciesList[0].description : "";
        }

        let FX = fields.FX;
        if (updateFX) {
          const settleCurrency = settlementCurrencies.find(
            (c) => c.currencyInfo.currencyId == settleCurrencyId
          );
          FX = parseFloat(settleCurrency.fx);
        }

        this.setState((state) => ({
          fields: {
            ...state.fields,
            tradeCurrencySymbol: tradeCurrencyISO,
            settlementCurrencyId: settleCurrencyId,
            settlementCurrencySymbol: settleCurrencySymbol,
            FX,
            settlementCurrencies: settlementCurrenciesList,
          },
        }));
      }
      if (updateValueDate) {
        const valueDate = items.find((i) => i.key == "SettlementDayDate");
        this.setState((state) => ({
          fields: {
            ...state.fields,
            valueDate: valueDate.value,
          },
        }));
      }
    });
  };

  onChange = (name, { values, value }) => {
    const _value = values || value;
    const ui = { ...this.state.ui };
    const fields = {};

    if (["side", "form", "asset", "price"].includes(name)) {
      ui.distributed = false;
    }
    if (name == "form") {
      fields.asset = { id: null, name: "" };
    }
    if (name == "settlementCurrencyId") {
      fields.settlementCurrencySymbol = this.state.fields.settlementCurrencies.filter((c) => {
        return c.id == value;
      })[0].description;
    }
    if (name == "tradeCurrency") {
      fields.tradeCurrencyId = values.id;
      fields.tradeCurrencySymbol = values.name;
    }

    this.setState(
      (state) => ({
        fields: {
          ...state.fields,
          ...fields,
          [name]: _value,
        },
        errors: {
          ...state.errors,
          [name]: undefined,
        },
        ...ui,
      }),
      () => this.refreshTotals(false)
    );
  };

  changeItem = (id, name, value) => {
    const item = this.state.items[id];
    const items = {
      ...this.state.items,
      [id]: {
        ...item,
        [name]: isNaN(value) || value == "" ? value : +value,
        [`error_${name}`]: undefined,
      },
    };
    this.setState(
      {
        items,
      },
      () => this.refreshTotals(true)
    );
  };

  changeTrading = (fields) => {
    this.setState(
      (state) => ({
        items: {
          ...state.items,
          trading: {
            ...state.items.trading,
            ...fields,
          },
        },
      }),
      () => this.refreshTotals(true)
    );
  };

  toggleItem = (id) => {
    const item = this.state.items[id] || { enabled: false };
    const { orders } = this.state.entities;

    const order = orders.find((o) => o.Order.OrderId == id);

    if (!item.enabled) {
      let remainingQty = this.state.fields.quantity;

      Object.entries(this.state.items).forEach((e) => (remainingQty -= e[1].enabled ? +e[1].quantity : 0));

      if (remainingQty > 0 || this.isReadonlyTrade()) {
        item.quantity = Math.max(Math.min(remainingQty, +order.Order.stats.pending), 0);
      }
    }

    this.setState(
      (state) => ({
        items: {
          ...state.items,
          [id]: {
            ...item,
            loading: false,
            enabled: !item.enabled,
            error_price: item.enabled ? undefined : item.error_price,
            error_quantity: item.enabled ? undefined : item.error_quantity,
          },
        },
      }),
      () => this.refreshTotals(true)
    );
  };

  toggleItemAccount = (id) => {
    const item = this.state.items[id] || { enabled: false };

    if (!item.enabled) {
      let remainingQty = this.state.fields.quantity;

      Object.entries(this.state.items).forEach((e) => (remainingQty -= e[1].enabled ? +e[1].quantity : 0));

      if (remainingQty > 0 || this.isReadonlyTrade()) {
        item.quantity = remainingQty;
      }
    }

    this.setState(
      (state) => ({
        items: {
          ...state.items,
          [id]: {
            ...item,
            loading: false,
            enabled: !item.enabled,
            error_price: item.enabled ? undefined : item.error_price,
            error_quantity: item.enabled ? undefined : item.error_quantity,
          },
        },
      }),
      () => this.refreshTotals(true)
    );
  };

  refreshTotals = (updateTradeQuantity) => {
    const { ui, fields, items, maxDecimals } = this.state;
    const { leftOvers: oldLeftOvers } = ui;
    let leftOvers = null;

    //if (ui.distributed) {
    // sum all enabled items
    let sum = 0;
    Object.values(items).forEach((e) => {
      if (e.sides) {
        if (fields.side == "Buy") {
          e.sides.buy.forEach((item) => {
            sum +=
              item.isFromThisTrade && item.quantity && !isNaN(parseFloat(item.quantity))
                ? +parseFloat(item.quantity)
                : 0;
          });
        } else {
          e.sides.sell.forEach((item) => {
            sum +=
              item.isFromThisTrade && item.quantity && !isNaN(parseFloat(item.quantity))
                ? +parseFloat(item.quantity)
                : 0;
          });
        }
      } else {
        sum += e.enabled && !isNaN(parseFloat(e.quantity)) ? +parseFloat(e.quantity) : 0;
      }
    });

    sum = parseFloat(sum).toFixed(maxDecimals);

    let quantity = parseFloat(fields.quantity);
    if (updateTradeQuantity && oldLeftOvers == 0 && !this.isReadonlyTrade()) {
      // If leftovers was 0, then the quantity of the trade was equal to the sum of the orders.
      // We keep it that way.
      quantity = sum;
    }

    leftOvers = quantity - sum;
    //}

    this.setState((state) => ({
      fields: {
        ...state.fields,
        quantity,
      },
      ui: {
        ...state.ui,
        leftOvers,
      },
    }));
  };

  validate = () => {
    let { items } = this.state;
    const { orders } = this.state.entities;

    let hasErrors = false;
    let hasItems = false;
    const errors = {
      counterparty: undefined,
      route: undefined,
      global: undefined,
    };
    const { route, counterparty, form, side, asset, price, date, valueDate } = this.state.fields;

    if (counterparty.id === undefined || counterparty.id === null) {
      errors.counterparty = "Required field";
      hasErrors = true;
    }
    if (route === undefined || route === null) {
      errors.route = "Required field";
      hasErrors = true;
    }
    errors.date = null;
    errors.valueDate = null;
    if (date === undefined || date === null) {
      errors.date = "Required field";
      hasErrors = true;
    }
    if (valueDate === undefined || valueDate === null) {
      errors.valueDate = "Required field";
      hasErrors = true;
    }

    let dateAux = new Date(date);
    dateAux = new Date(`${dateAux.toDateLocal()}T00:00`);
    const valueDateAux = new Date(`${valueDate}T00:00`);
    if (dateAux > valueDateAux) {
      errors.date = "Trade date should be before or at value date";
      errors.valueDate = "Value date should be after or at trade date";
      hasErrors = true;
    }

    const tradeDate = dateAux;

    Object.entries(items).forEach(([name, value]) => {
      const order = orders.find((o) => o.Order.OrderId == name);

      if (value.enabled) {
        if (name !== "trading") {
          if (!value.quantity || value.quantity === "") {
            items[name].error_quantity = "Required field";
            hasErrors = true;
          } else if (order && value.quantity > +order.Order.stats.pending) {
            items[name].error_quantity = "Quantity is over order";
            hasErrors = true;
          }

          if (!order && value.account == undefined) {
            items[name].error_account = "Required field";
            hasErrors = true;
          }
        }
        hasItems = true;
      }
    });

    const tradingValid = this.tradingRef.current.validate();

    if (this.state.ui.leftOvers < 0) {
      errors.global = "Total execution quantity is over quanttiy";
      hasErrors = true;
    } else if (tradingValid.error) {
      errors.global = tradingValid.global;
      hasErrors = true;
    }

    this.setState((state) => ({
      items,
      errors: {
        ...state.errors,
        ...errors,
      },
    }));

    return !hasErrors;
  };

  execute = () => {
    if (this.validate()) {
      const { fetchUpdateTradeAndComposition } = this.props.services;
      const { fields, items, entities } = this.state;
      const {
        tradeId,
        asset,
        route,
        side,
        quantity,
        price,
        date,
        valueDate,
        form,
        counterparty,
        settlementCurrencyId,
        FXRoute,
        FX,
        settlementCurrencies,
        booktype,
        balancetype
      } = fields;
      const tradings = this.tradingRef.current.values();

      const settleCurrency = settlementCurrencies.find((c) => c.id == settlementCurrencyId);
      let multiplies = true;
      if (settleCurrency) {
        multiplies = settleCurrency.multiplies;
      }
      let tradeAndComposition = {
        TradeId: tradeId,
        TradeSide: side,
        TradeAssetClassForm: form,
        TradeAssetId: asset.id,
        TradeQuantity: quantity,
        TradeAvgPrice: price,
        TradingRouteId: route["id"] ? route.id : route,
        CounterPartyId: counterparty.id,
        TradeTradeDateTime: date,
        TradeValueDate: valueDate,
        TradeSettleCurrencyId: settlementCurrencyId,
        TradeFXRoute: FXRoute,
        TradeFX: FX,
        TradeFXMultiplies: multiplies,
        Orders: [],
        TradeBookType: booktype,
        TradeBalanceType: balancetype
      };

      let orders = [];

      Object.entries(items).forEach((entry) => {
        const [id, value] = entry;

        if (value.enabled) {
          switch (id) {
            case "account":
              orders.push({
                ParentOrderId: value.orderId ? value.orderId : 0,
                AccountId: value.account,
                Quantity: value.quantity,
                Side: side,
                RelationType: "Prop",
                Price: price,
                IsFromRelatedTradeOrder: false,
              });
              break;
            case "errorAccount":
              orders.push({
                ParentOrderId: value.orderId ? value.orderId : 0,
                AccountId: value.account,
                Quantity: value.quantity,
                Side: side,
                RelationType: "Error",
                Price: price,
                IsFromRelatedTradeOrder: false,
              });
              break;
            case "trading":
              let firstSide;
              let secondSide;
              let firstSideCap;
              let secondSideCap;
              if (side === "Buy") {
                firstSide = "buy";
                secondSide = "sell";
                firstSideCap = "Buy";
                secondSideCap = "Sell";
              } else {
                firstSide = "sell";
                secondSide = "buy";
                firstSideCap = "Sell";
                secondSideCap = "Buy";
              }

              value.sides[firstSide].forEach((item) => {
                orders.push({
                  ParentOrderId: item.orderId ? item.orderId : 0,
                  AccountId: 0,
                  Quantity: item.quantity,
                  Side: firstSideCap,
                  RelationType: "Trading",
                  Price: item.price,
                  IsFromRelatedTradeOrder: item.tradeId > 0 ? true : false,
                  RelatedTradeInfo: {
                    CounterPartyId: item.counterpartyId,
                    TradingRouteId: item.route,
                    TradeTradeDateTime: item.date,
                    TradeAvgPrice: item.price,
                    Source: item.source,
                  },
                });
              });

              value.sides[secondSide].forEach((item) => {
                orders.push({
                  ParentOrderId: item.orderId ? item.orderId : 0,
                  AccountId: 0,
                  Quantity: item.quantity,
                  Side: secondSideCap,
                  RelationType: "Trading",
                  Price: item.price,
                  IsFromRelatedTradeOrder: true,
                  RelatedTradeInfo: {
                    CounterPartyId: item.counterpartyId,
                    TradingRouteId: item.route,
                    TradeTradeDateTime: item.date,
                    TradeAvgPrice: item.price,
                    Source: item.source,
                  },
                });
              });

              break;
            default:
              // It is a client order
              orders.push({
                ParentOrderId: id,
                AccountId: 0,
                Quantity: value.quantity,
                Side: side,
                RelationType: "Client",
                Price: price,
                IsFromRelatedTradeOrder: false,
              });
          }
        }
      });

      tradeAndComposition.Orders = orders;

      this.setState((state) => ({
        loadings: {
          ...state.loadings,
          execute: true,
        },
      }));

      let body = {
        tradeAndComposition,
      };

      fetchUpdateTradeAndComposition(body).then((r) => {
        this.setState((state) => ({
          loadings: {
            ...state.loadings,
            execute: false,
          },
        }));

        if (r.response.result.Code == 200) {
          this.props.toggle();
        } else {
          alert(r.response.result.Description);
        }
      });
    }
  };

  categorizeFetchedOrders(orders = []) {
    const { fields, items } = this.state;

    const tradingWasEnabled = items.trading.enabled;

    let orderItems = {};
    let orderItemsKey = "";
    let account = 0;
    let orderId = 0;

    let clientOrders = [];
    let propOrders = [];
    let errorOrders = [];

    let tradingSides = {
      buy: [],
      sell: [],
    };

    let tradingIsEnabled = false;

    orders.forEach((o) => {
      o.Order.stats = {
        pending: parseFloat(o.PendingQuantity),
      };

      orderItemsKey = "";
      account = 0;
      orderId = o.ParentOrderId;
      switch (o.RelationType) {
        case "Client":
          clientOrders.push(o);
          orderItemsKey = o.ParentOrderId;
          break;

        case "Prop":
          propOrders.push(o);
          orderItemsKey = "account";
          account = o.Order.CurrentAccount.AccountId;
          break;

        case "Error":
          errorOrders.push(o);
          orderItemsKey = "errorAccount";
          account = o.Order.CurrentAccount.AccountId;
          break;

        case "Trading":
          if (!tradingWasEnabled) {
            const newId = Math.random().toString(36).substr(2, 4);

            let sideItem = {
              id: newId,
              isFromThisTrade: !o.IsFromRelatedTradeOrder,
              orderId: o.ParentOrderId,
              price: o.RelatedTradeInfo ? o.RelatedTradeInfo.TradeAvgPrice : fields.price,
              disabled: o.IsFromRelatedTradeOrder,
              quantityDisabled: o.RelationIsBooked,
              tradeId: o.RelatedTradeInfo ? o.RelatedTradeInfo.TradeId : 0,
              date: o.RelatedTradeInfo
                ? localDateTime(o.RelatedTradeInfo.TradeTradeDateTime).toDatetimeLocal()
                : localDateTime(fields.date).toDatetimeLocal(),
              route: o.RelatedTradeInfo ? o.RelatedTradeInfo.TradingRouteId : null,
              counterpartyId: o.RelatedTradeInfo ? o.RelatedTradeInfo.CounterPartyId : null,
              counterpartyName: o.RelatedTradeInfo ? o.RelatedTradeInfo.CounterPartyName : null,
              quantity: o.Quantity,
            };
            if (o.Side == "Buy") {
              tradingSides.buy.push(sideItem);
            } else {
              tradingSides.sell.push(sideItem);
            }
            tradingIsEnabled = true;
          }

          break;

        default:
          break;
      }

      if (orderItemsKey !== "") {
        orderItems[orderItemsKey] = {
          enabled: o.Quantity > 0,
          readonly: o.RelationIsBooked,
          quantity: o.Quantity,
          account,
          orderId,
        };
      }
    });

    if (tradingWasEnabled && items.trading.sides.buy && items.trading.sides.sell) {
      tradingSides.buy = items.trading.sides.buy;
      tradingSides.sell = items.trading.sides.sell;
    } else {
      let defaultSideItem = {
        id: 1,
        price: fields.price,
        route: null,
        date: new Date().toDatetimeLocal(),
      };
      if (tradingSides.buy.length == 0) {
        tradingSides.buy.push({
          ...defaultSideItem,
          isFromThisTrade: fields.side == "Buy",
        });
      }
      if (tradingSides.sell.length == 0) {
        tradingSides.sell.push({
          ...defaultSideItem,
          isFromThisTrade: fields.side == "Sell",
        });
      }
    }

    return {
      orderItems,
      clientOrders,
      propOrders,
      errorOrders,
      tradingSides,
      tradingIsEnabled,
    };
  }

  isReadonlyTrade = () => {
    const { fields } = this.state;
    const { tradeStatus, tradeGroupId } = fields;

    const isConfirmedTrade =
      tradeStatus && ["ConfirmationSent", "Matched", "Booked", "Canceled"].indexOf(tradeStatus) >= 0;

    return tradeGroupId > 0 || isConfirmedTrade;
  };

  toggleShowFees = () => {
    this.setState({
      ...this.state,
      showFees: !this.state.showFees,
    });
  };

  render() {
    const { toggle, open, counterparties, services } = this.props;
    const { entities, loadings, items, fields, errors, ui, maxDecimals, showFees } = this.state;
    const { tradeId, side, price, tradeGroupId } = fields;
    const itemActions = {
      toggle: this.toggleItem,
      change: this.changeItem,
    };

    let orders = [];

    if (ui.distributed || (entities.orders && entities.orders.length > 0)) {
      orders = entities.orders;
    }

    const isNewTrade = tradeId == 0;
    const isReadonlyTrade = this.isReadonlyTrade();

    let tradeAndGroupId = `#${tradeId}`;
    if (tradeGroupId > 0) {
      tradeAndGroupId += ` (group #${tradeGroupId})`;
    }

    /*
		let totalEnabledQuantity = Object.values(items).forEach((e) => {
			sum += e.enabled && !isNaN(e.quantity) ? +e.quantity : 0;
		});
		*/
    let tradeHasSelectedOrders = Object.values(items).find((i) => {
      return i.enabled;
    });

    return (
      <Modal isOpen={open} toggle={toggle} className={style.modal}>
        <ModalHeader toggle={toggle}>
          {tradeId > 0 ? `Edit trade ${tradeAndGroupId}` : "New trade"}
        </ModalHeader>
        <ModalBody style={{ padding: "3px 20px", minHeight: "225px" }}>
          <HeaderForm
            fields={fields}
            errors={errors}
            onChange={this.onChange.bind(this)}
            isNewTrade={isNewTrade}
            isReadonlyTrade={isReadonlyTrade}
            tradeHasSelectedOrders={tradeHasSelectedOrders}
            services={services}
            booktypes={this.state.entities.booktypes}
          />

          <Line mb={"8px"} />
          <Row>
            <Col lg={12}>
              {loadings.distribute ? (
                <CircularProgress sm style={{ margin: "8px auto" }} />
              ) : (
                orders.length == 0 && <EmptyOrders />
              )}
              {
                /*ui.distributed &&*/
                orders.map((o, i) => (
                  <ItemRow
                    key={`order=${i}`}
                    id={o.ParentOrderId}
                    order={o.Order}
                    item={items[o.ParentOrderId]}
                    actions={itemActions}
                    priceDisabled
                    showPrice={false}
                    maxDecimals={maxDecimals}
                  />
                ))
              }
              <ItemRow
                id={"account"}
                item={items["account"]}
                actions={{ ...itemActions, toggle: this.toggleItemAccount }}
                priceDisabled
                showPrice={false}
                title={"Prop"}
                maxDecimals={maxDecimals}
              >
                <AccountsField
                  id={"account"}
                  accounts={entities.accounts}
                  onChange={this.changeItem}
                  item={items["account"]}
                />
              </ItemRow>
              <ItemRow
                id={"errorAccount"}
                item={items["errorAccount"]}
                actions={{ ...itemActions, toggle: this.toggleItemAccount }}
                priceDisabled
                showPrice={false}
                title={"Error"}
                maxDecimals={maxDecimals}
              >
                <AccountsField
                  id={"errorAccount"}
                  accounts={entities.errorAccounts}
                  onChange={this.changeItem}
                  item={items["errorAccount"]}
                />
              </ItemRow>

              <Trading
                ref={this.tradingRef}
                price={price}
                counterparties={counterparties}
                tradeRoutes={entities.routes}
                tradings={items.trading}
                fixedSide={side.toLowerCase()}
                onChange={this.changeTrading}
                sidesAux={items.trading.sides}
                maxDecimals={maxDecimals}
              />
            </Col>
          </Row>
          <Line />
          <FooterForm
            fields={fields}
            errors={errors}
            onChange={this.onChange}
            tradeRoutes={entities.routes}
            counterparties={counterparties}
            isReadonlyTrade={isReadonlyTrade}
          />
          {fields.Fees && (
            <React.Fragment>
              <span className={style.showFeesLink} onClick={this.toggleShowFees}>
                Show fees
              </span>
              {showFees && <Fees fees={fields.Fees} />}
            </React.Fragment>
          )}
          <AlertError error={errors.global} />
        </ModalBody>

        <ModalFooter className={style.footer}>
          <div className={style.content}>
            {ui.leftOvers != null && <Totals side={side} leftOvers={ui.leftOvers} />}
          </div>
          <div className={style.actions}>
            {!false && (
              <Button color="light" onClick={toggle}>
                Close
              </Button>
            )}{" "}
            <LaddaButton
              className={"btn btn-ladda btn-primary ml-1"}
              loading={loadings.execute}
              //disabled={!ui.distributed}
              onClick={() => this.execute()}
              data-style={EXPAND_RIGHT}
            >
              {tradeId && tradeId > 0 ? "Update" : "Execute"}
            </LaddaButton>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

Trade.defaultFieldsFromTrade =
  (trade = {}) =>
  () => ({
    tradeId: trade.TradeId,
    tradeStatus: trade.TradeStatus,
    tradeGroupId: trade.TradeRefTradeGroupId || 0,
    form: trade.TradeAssetClassForm || ProductType.BOND,
    side: trade.TradeSide === "SELL" ? "Sell" : "Buy",
    asset: { id: trade.TradeAssetId || null, name: trade.TradeAssetTicker || null },
    quantity: trade.TradeQuantity ? trade.TradeQuantity : 0,
    price: trade.TradeAvgPrice ? trade.TradeAvgPrice : 0,
    route: trade.TradeTradingRouteId ? trade.TradeTradingRouteId : null,
    counterparty: trade.TradeCounterPartyId
      ? { id: trade.TradeCounterPartyId, name: trade.TradeCounterPartyName }
      : { id: null, name: "" },
    date: trade.TradeId ? trade.TradeTradeDateTime : new Date().toDatetimeLocal(),
    valueDate: trade.TradeId ? trade.TradeValueDate : "",
    tradeCurrencyId: trade.TradeTradeCurrencyId || 0,
    tradeCurrencySymbol: trade.TradeTradeCurrencyISO || "",
    settlementCurrencyId: trade.TradeSettleCurrencyId || 0,
    settlementCurrencySymbol: trade.TradeSettleCurrencyISO || "",
    FXRoute: trade.TradeFXRoute || "FXThroughCpty",
    FXRelatedOrderId: trade.TradeFXRelatedOrderId ? trade.TradeFXRelatedOrderId : 0,
    FX: trade.TradeFX || 1,
    manualFX: trade.TradeId,
    balancetype: trade.TradeBalanceType,
    booktype: trade.TradeBookType
  });

Trade.defaultFieldsFromOrder =
  (order = {}) =>
  () => ({
    tradeId: 0,
    tradeStatus: "",
    tradeGroupId: 0,
    form: order.AssetClassForm || ProductType.BOND,
    side: order.OrderSide || "Buy",
    asset: { id: order.AssetId || null, name: order.AssetTicker || null },
    quantity: order.OrderQuantity ? +order.stats.pending : "",
    price: order.OrderType && order.OrderType == OrderPriceType.LIMIT ? +order.OrderPrice : "",
    route: null,
    counterparty: { id: null, name: "" },
    date: new Date().toDatetimeLocal(),
    valueDate: "",
    tradeCurrencyId: order.OrderCurrencyId || 0,
    tradeCurrencySymbol: order.OrderCurrencySymbol || "",
    settlementCurrencyId: order.OrderSettlementCurrencyId || 0,
    settlementCurrencySymbol: order.OrderSettlementCurrencySymbol || "",
    FXRoute: "FXThroughCpty",
    FXRelatedOrderId: 0,
    FX: 1,
    manualFX: false,
  });

const Totals = ({ side, leftOvers }) => (
  <div className={style.box}>
    <div className={style.container}>
      <strong>Leftovers</strong>
      <table>
        <tbody>
          {side == "Buy" && (
            <tr>
              <td style={{ color: "#4dbd74", fontWeight: 500 }}>Buy side</td>
              <td>
                <Number value={leftOvers} dataTypeDecimalName="currency" />
              </td>
            </tr>
          )}

          {side == "Sell" && (
            <tr>
              <td style={{ color: "#f86c6b", fontWeight: 500 }}>Sell side</td>
              <td>
                <Number value={leftOvers} dataTypeDecimalName="currency" />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);
export const AccountsField = ({ accounts, id, onChange, item }) =>
  accounts == null ? (
    <CircularProgress sm style={{ margin: "30px 0 0 25px" }} />
  ) : (
    <React.Fragment>
      {item.orderId && item.orderId > 0 && (
        <div
          style={{
            textAlign: "center",
            marginRight: "15px",
            paddingTop: "7px",
          }}
        >
          Order
          <br />
          <b>#{item.orderId}</b>
        </div>
      )}
      <Field label={"Account"} error={item.error_account}>
        <Combobox
          value={item.account}
          disabled={!item.enabled || item.readonly}
          items={accounts}
          invalid={!!item.error_account}
          onChange={(v) => onChange(id, "account", v)}
          emptyLabel={"Account"}
        />
      </Field>
    </React.Fragment>
  );

const filterOrders = (orders, { form, side, asset, price }) => {
  if (orders.working == null) return [];

  let filtered = [...orders.todo, ...orders.working].filter((o) => {
    if (o.AssetClassForm == form && o.OrderSide == side && o.AssetTicker == asset) {
      if (o.OrderType == OrderPriceType.LIMIT) {
        if (
          (o.OrderSide == "Buy" && +o.OrderPrice < +price) ||
          (o.OrderSide == "Sell" && +o.OrderPrice > +price)
        ) {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  });

  filtered.sort((o1, o2) => {
    if (o1.OrderStatus == o2.OrderStatus) {
      return o1.OrderModifiedDate - o2.OrderModifiedDate;
    }

    if (o1.OrderStatus == OrderStatus.ACKED && o2.OrderStatus == OrderStatus.ROUTED) {
      return -1;
    }

    if (o1.OrderStatus == OrderStatus.PART) {
      return -1;
    }

    return 1;
  });

  return filtered;
};

export const Line = ({ mb = "4px" }) => (
  <hr
    style={{
      margin: `4px 0px ${mb} 0px`,
      borderTop: "solid 1px lightgray",
    }}
  />
);

const Fees = ({ fees }) => {
  return (
    <div className={style.feesContainer}>
      <Table className={style.feesTable} responsive>
        <tbody>
          {fees.map((feeItem, idx) => (
            <tr key={idx}>
              <td>
                {feeItem.Description}:{" "}
                <FormattedNumber value={feeItem.FeeAmount} dataTypeDecimalName="currency" />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default Trade;
